import { array, number, object } from "superstruct";

export const RewardsProductVariantSchema = object({
    variantId: number(),
    pointsAmount: number(),
});

const RewardsEarnPointsSchema = object({
    amountForProduct: object({
        productId: number(),
        pointsAmount: number(),
        variants: array(RewardsProductVariantSchema),
    }),
});

export default RewardsEarnPointsSchema;
